import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { ListItemText } from '@material-ui/core';
import { ListItem } from '@material-ui/core';
import { List } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import { observer } from 'mobx-react';
import { IObservableObject, IObservableValue, observable } from 'mobx';
import { Paper } from '@material-ui/core';
import { defaultPageable, Pageable } from '../../api/pageable';
import PaginationNavigation from '../../components/PaginationNavigation';
import { QuestionCatalogueDto } from './qustionCatalogueTypes';
import { getQuestionCatalogues } from './questionCatalogueApi';
import EmptyPage from '../../components/emptyPage/EmptyPage';
import { translation } from '../../i18n';
import { log } from '../../logConfig';
import { RouteComponentProps, withRouter } from 'react-router';
import { CREATE_CATALOGUE_ROUTE } from '../../router/routes';
import QuestionCatalogueDialog from './QuestionCatalogueDialog';
import { withQuestionCataloguePage } from '../../router/Loaders';
import { Fab } from '@material-ui/core';

interface Props {
  renderSearch: (showSearch: boolean) => void;
  searchText: IObservableValue<string>;
}

type LocalStyles = 'root' | 'button';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    textAlign: 'center',
  },
  button: {
    margin: theme.spacing.unit,
    right: theme.spacing.unit * 2,
    bottom: theme.spacing.unit * 2,
    position: 'fixed'
  },
});

type PropsWithStyle = WithStyles<LocalStyles> & RouteComponentProps & Props;

@observer
class QuestionCatalogueList extends React.Component<PropsWithStyle, {}> {

  @observable private pageAble: Pageable = defaultPageable();
  @observable private catalogue: QuestionCatalogueDto & IObservableObject;
  private open: IObservableValue<boolean> = observable.box(false);

  constructor(props: PropsWithStyle) {
    super(props);
    this.props.renderSearch(true);
  }

  public render() {
    const {classes} = this.props;
    return (
      <>
        {
          withQuestionCataloguePage(
            () => getQuestionCatalogues({searchText: this.props.searchText.get()}, this.pageAble),
            'withPage' + this.pageAble.page + this.props.searchText,
            questionCatalogue =>
              <>
              {(questionCatalogue.content.length === 0) ?
                <EmptyPage message={translation.t('noEntry.questionCatalogue.title')}
                           searchText={this.props.searchText.get()}
                           displayFab={true} onFabClicked={() => {
                  log.info('')
                }}/> :
                <Paper elevation={1} className={this.props.classes.root}>
                  <List>
                    {questionCatalogue.content.map(value => (
                      <ListItem
                        key={value.id}
                        button={true}
                        onClick={() => this.openDialog(value)}
                      >
                        <ListItemText primary={`${value.title}`}/>
                      </ListItem>
                    ))}
                  </List>
                  <PaginationNavigation
                    totalPages={questionCatalogue.totalPages}
                    page={questionCatalogue.pageable.pageNumber!!}
                    onChangePage={this.handleChangePage}/>
                  <Fab color="primary" arial-label="Add" className={classes.button} onClick={() => this.props.history.push(CREATE_CATALOGUE_ROUTE.route)}>
                    <AddIcon/>
                  </Fab>
                </Paper>
              }
            </>
          )
        }
        <QuestionCatalogueDialog onClose={() => this.open.set(false)} catalogue={this.catalogue} open={this.open.get()}/>
      </>
    );
  }

  private openDialog(catalogue: QuestionCatalogueDto) {
    this.catalogue = observable(catalogue);
    this.open.set(true);
  }

  private handleChangePage = (event: any, page: number) => {
    this.pageAble.page = page;
  };
}

export default withRouter(withStyles(localStyles)(QuestionCatalogueList));
